import type { QuizResult } from '@/types/quiz'
import { SHOPIFY_BASE_URL } from './config'

/**
 * Source of the visitor - Shopify Flow keys off this cart attribute to tag
 * the order and customer. 'quiz_direct' = clicked CTA on the result screen;
 * 'quiz_email' = clicked CTA from a Klaviyo email after the fact.
 */
export type QuizSource = 'quiz_direct' | 'quiz_email'

/**
 * Build a Shopify product URL carrying the quiz's attribution params.
 *
 * These ride as plain `?quiz_source=...&quiz_cut=...` query params. Shopify does
 * NOT persist `attributes[...]` from a product-page URL, so the live theme's
 * `quiz-attribution` snippet reads these params on landing and writes them to
 * the cart via the Cart AJAX API (/cart/update.js). The cart attributes then
 * carry through to order creation, where Shopify Flow tags the order
 * (quiz-direct / quiz-email) and the dashboard reads them for reporting.
 *
 * Keep these keys in sync with the snippet in np-theme: snippets/quiz-attribution.liquid.
 */
export function buildProductUrl(
  handle: string,
  source: QuizSource,
  result: Pick<QuizResult, 'recommended_cut' | 'recommended_length'> & {
    bodyShape: string
  },
): string {
  const query = new URLSearchParams({
    quiz_source: source,
    quiz_cut:    result.recommended_cut,
    quiz_length: result.recommended_length,
    quiz_shape:  result.bodyShape,
    quiz_match:  'true',
  }).toString()

  return `${SHOPIFY_BASE_URL}/products/${encodeURIComponent(handle)}?${query}`
}
